import { AnimatedImage, AnimatedImageProps } from '@unistocks/components/basic/image';
import { Pressable, PressableProps } from '@unistocks/components/basic/pressable';
import { LOGO_DARK, LOGO_LIGHT } from '@unistocks/shared/consts';
import { useIsDarkMode } from '@unistocks/shared/hooks/use-active-color-scheme';
import React from 'react';
import { StyleSheet } from 'react-native';

const ASPECT_RATIO = 830 / 213; // logo width / logo height

export type LogoProps = Omit<PressableProps, 'children'> & {
  imageProps?: Omit<AnimatedImageProps, 'source'>;
};

export const Logo: React.FC<LogoProps> = ({
  imageProps: { style: imageStyle, ...imageProps } = {},
  ...props
}) => {
  const isDarkMode = useIsDarkMode();

  return (
    <Pressable
      h={'$4.5'}
      overflow={'hidden'}
      justifyContent={'center'}
      alignItems={'center'}
      {...props}
    >
      <AnimatedImage
        source={isDarkMode ? LOGO_DARK : LOGO_LIGHT}
        contentFit={'contain'}
        {...imageProps}
        style={imageStyle ?? style.logo}
      />
    </Pressable>
  );
};

const style = StyleSheet.create({
  logo: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    aspectRatio: ASPECT_RATIO
  }
});
